import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Grid, P, TextField } from '@decisiv/ui-components';
import { t, Trans } from '@lingui/macro';
import { FormGroup } from './StyledComponents';
import FeatureInfoDrawer from './FeatureInfoDrawer';

const IntegrationTimeoutSettings = ({
  edit,
  timeout,
  errors,
  handleTextChange,
  validateTimeout,
}) => (
  <>
    <Grid.Column span="2">
      <FeatureInfoDrawer
        heading={<Trans>Timeout</Trans>}
        ariaLabel={t`More information about Timeout`}
      >
        <ul>
          <li>
            <Trans>
              Sets the maximum number of seconds the integration waits for a
              partner response before aborting the request and treating it as
              failed.
            </Trans>
          </li>
          <li>
            <Trans>
              A timed-out request is handled like any other failure: it can
              trigger an automatic retry (for application events integrations)
              and counts toward the Circuit Breaker’s failure threshold. The
              timeout is enforced as the HTTP client’s read/open timeout,
              configured per integration (default 15s; allowed range 1-60s). A
              timeout raises a status-less error that defaults to status 500,
              which is why it is eligible for both retry and the Circuit
              Breaker.
            </Trans>
          </li>
        </ul>
      </FeatureInfoDrawer>
    </Grid.Column>
    <Grid.Column>
      {edit ? (
        <FormGroup key="timeout">
          <Grid.Column>
            <span className="spanDetail">
              <P>Timeout</P>
            </span>
            <span>
              <P>{timeout} seconds</P>
            </span>
          </Grid.Column>
        </FormGroup>
      ) : (
        <FormGroup key="timeoutEdit">
          <Flex style={{ marginTop: '0.375rem' }}>
            <TextField
              label={t`Timeout in seconds`}
              name={t`timeout`}
              required
              type="number"
              value={String(timeout)}
              onChange={handleTextChange}
              onBlur={validateTimeout}
              warningMessage={errors.timeout}
              maxLength={6}
            />
          </Flex>
        </FormGroup>
      )}
    </Grid.Column>
  </>
);

IntegrationTimeoutSettings.propTypes = {
  edit: PropTypes.bool.isRequired,
  timeout: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  handleTextChange: PropTypes.func.isRequired,
  validateTimeout: PropTypes.func.isRequired,
};

export default IntegrationTimeoutSettings;
